exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-collapse-narrow{max-width:120px;min-width:60px}.notification-collapse-narrow .task-exp{padding:5px 10px}.notification-count{font-size:1rem}.notification-close-text,.notification-count{font-weight:600;color:#495057;white-space:nowrap}.notification-close-text{font-size:.875rem;margin-right:5px}.notification-collapse-narrow .icon img{width:12px;height:12px}", ""]);

// exports
